import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenService } from './token.service'; // Adjust path as needed

declare var jQuery: any;

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, ) {}

    canActivate(): boolean {
        const token = TokenService.getToken();

        // Check if token is invalid
        if (!token || token.UserId === '' || token.SessionId === 0) {
            this.router.navigate(['/login']); // Redirect to login page
            this.showMessage('Login Required', '0', 'Please log in to continue.');
            return false; // Prevent navigation
        }

        return true; // Allow navigation
    }

    truncateString(str, num) {
      if(str!=null){
        return str.length > num ? str.slice(0, num) + '...' : str;
      } else {
        return ''
      }
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
      let truncatedAdditionalInfo = this.truncateString(additionalInfo, 1000);
      jQuery('#PopupMessageTitle').html(title);
      jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (truncatedAdditionalInfo ? ' -- ' + truncatedAdditionalInfo : ''));
      jQuery('#PopupMessage').modal('show');
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/security/auth-guard.ts